import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import {
  Form as BaseForm,
  TextAreaField,
  DateField,
  CancelPopupButton,
  SubmitButton,
} from 'ui/FormElement';
import { useContext } from 'components/ResourceNotes/Context';

export default function Form({ closeForm }) {
  const { dispatch, actions, state } = useContext();
  const [loader, setLoader] = useState(false);

  function dateFormat(value) {
    const date = new Date(value);
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };

    return date.toLocaleDateString('en-US', options);
  }

  const validationSchema = {
    date: Yup.string().required('Date is required'),
    body: Yup.string().required('Content is required'),
  };

  const formSchema = Yup.object().shape(validationSchema);

  const initialValues = {
    date: dateFormat(new Date()),
    body: '',
  };

  const formSendSuccess = () => {
    swal({
      title: 'Note Created!',
      text: '',
      html: true,
      type: 'success',
      showCancelButton: false,
      confirmButtonText: 'Close',
      closeOnConfirm: true,
    });
  };

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setLoader(true);

    actions.create(
      dispatch,
      state.resourceType,
      state.resourceId,
      values,
      () => {
        setLoader(false);
        closeForm();
        formSendSuccess();
      },
      (errors) => {
        const newErrors = {};
        errors.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
        setLoader(false);
      },
    );
  };

  return (
    <BaseForm
      validationSchema={formSchema}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      <DateField
        name="date"
        label={(
          <>
            <span>Date</span>
            <abbr title="required">*</abbr>
          </>
        )}
      />

      <TextAreaField
        name="body"
        rows={4}
        label={(
          <>
            <span>Content</span>
            <abbr title="required">*</abbr>
          </>
        )}
        style={{ resize: 'vertical' }}
      />

      <div className="text-center mt50 mb30">
        <CancelPopupButton
          className="btn btn-primary btn-outline mr5 ml5 width-120"
          title="Cancel"
          onClick={closeForm}
        />

        <SubmitButton
          title={loader ? 'Please, wait ...' : 'Save'}
          disabled={loader}
          className="btn width-120 btn-primary submit-button mr5 ml5"
        />
      </div>
    </BaseForm>
  );
}

Form.propTypes = {
  closeForm: PropTypes.func.isRequired,
};
